import { theme } from "uikit";

import type { Order } from "../../../../../../../services";
import type { DateFns } from "../../../../../../../utils/DateFns";

const cellProcessing = (
	item: Order.Model,
	dateFns: DateFns,
	timezone: string,
) => {
	const isPreliminary =
		item.isPreliminary ||
		item?.additionalFields?.transfer?.lastReceivedOrder?.isPreliminary;

	const content = isPreliminary
		? dateFns.formatTime2(item.orderDate, "HH:mm:ss", {
				timezone,
				zeroSeconds: true,
		  })
		: "";

	return {
		content,
		backgroundColor: isPreliminary ? "#7B0078" : undefined,
		textColor: isPreliminary ? theme.colors.white : undefined,
	};
};

export default cellProcessing;
